export enum IncludeAttachmentType {
  none,
  thumbnailOnly,
  all,
}
